export type SearchParams = Record<string, string | string[] | undefined>;

export function readSearchParam(
  params: SearchParams,
  key: string,
): string | undefined {
  const value = params[key];
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}

export function readSearchArrayParam(params: SearchParams, key: string): string[] {
  const value = params[key];
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "string" && value.length > 0) {
    return [value];
  }
  return [];
}

type ReadFiniteIntParamOptions = {
  defaultValue: number;
  min?: number;
  max?: number;
};

function parseFiniteInteger(
  value: string | undefined,
  defaultValue: number,
): number {
  if (typeof value !== "string" || value.trim().length === 0) {
    return defaultValue;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return defaultValue;
  }

  return Math.trunc(parsed);
}

export function readFiniteIntParam(
  params: SearchParams,
  key: string,
  options: ReadFiniteIntParamOptions,
): number {
  const parsedValue = parseFiniteInteger(
    readSearchParam(params, key),
    options.defaultValue,
  );

  if (typeof options.min === "number" && parsedValue < options.min) {
    return options.min;
  }
  if (typeof options.max === "number" && parsedValue > options.max) {
    return options.max;
  }
  return parsedValue;
}
